import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { publicRoutes, sharedRoutes, userRoutes } from "./RouteData";
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n";
import HeaderLayout from "../components/Layouts/HeaderLayout/HeaderLayout";
import { useAppSelector } from "../store/hooks";
import { selectIsAuthenticated } from "../store/reducers/auth-reducer";
import LogInPage from "../pages/LogIn/LogIn";
import Error404 from "../pages/Error404/Error404";
import { ToastProvider } from "../hooks/useToast";
import ToastContainer from "../components/Toast/Toast";
import { PageTracker } from "../components/PageTracker/PageTracker";

const AppRouter = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return (
    <ToastProvider>
      <Router>
        <I18nextProvider i18n={i18n}>
          <PageTracker />
          <Routes>
            {!isAuthenticated && (
              <>
                {publicRoutes.map((route) => (
                  <Route
                    path={route.path}
                    key={route.path}
                    element={React.createElement(route.element, { key: route.path })}
                  />
                ))}
                <Route path="/*" element={<LogInPage />} />
              </>
            )}
            {isAuthenticated && (
              <>
                <Route element={<HeaderLayout />}>
                  {userRoutes.map((route) => (
                    <Route
                      path={route.path}
                      key={route.path}
                      element={React.createElement(route.element, { key: route.path })}
                    />
                  ))}
                </Route>
                <Route path="/*" element={<Error404 />} />
              </>
            )}
            {sharedRoutes.map((route) => (
              <Route
                path={route.path}
                key={route.path}
                element={React.createElement(route.element, { key: route.path })}
              />
            ))}
          </Routes>
        </I18nextProvider>
      </Router>
      <ToastContainer />
    </ToastProvider>
  );
};

export default AppRouter;
